// components/pages/TestManagement/AddTest/Phase3Container.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import OnJudgingPhase3 from './OnJudgingPhase3';
import ApprovedPhase3 from '../../TestModification/ApprovedTestEdit';
import AddTestPhase3 from './AddTestPhase3';
import { GameProposalDetailsAPI } from '../../TestManagementApi';

const Phase3Container: React.FC = () => {
  const { gameProposalId } = useParams();
  
  const { data: gameProposalDetailsData, isLoading } = useQuery<any>({
    queryKey: ["GameProposalOverview", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalDetailsAPI(Number(gameProposalId));
      return response.data;
    },
    // initialData: {
    //     "gameProposalId": 37,
    //     "status": "IN_PROGRESS",
    //     "testPlanStatus": "APPROVED_FINAL",
    //     "projectInfoStatus": "IN_PROGRESS",
    //     "questionCompositionStatus": "IN_PROGRESS",
    //     "previewAvailable": true,
    //     "submitAvailable": false
    // },
    enabled: !!gameProposalId
  });

  if (isLoading) {
    return <div>로딩 중...</div>;
  }
  
  const status = gameProposalDetailsData?.questionCompositionStatus;
  
  switch (status) {
    case 'SUBMITTED':
      return <OnJudgingPhase3 />;
    // case 'APPROVED':
    //   return <ApprovedPhase3 />;
    default:
      return <AddTestPhase3 />;
  }
};

export default Phase3Container;